import { resolvePageLayout } from '~/utils/layoutRouting';

export default defineNuxtRouteMiddleware((to) => {
  setPageLayout(resolvePageLayout(to.path));
});
